import { render, staticRenderFns } from "./BotaoAnexo.vue?vue&type=template&id=7315cd87&scoped=true"
import script from "./BotaoAnexo.vue?vue&type=script&lang=js"
export * from "./BotaoAnexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7315cd87",
  null
  
)

export default component.exports